import { VueConstructor } from 'vue'
import compenda, { EntityType, CreateGlobalHandlers, Errors } from '../card'

export interface CompendaFunctionsInterface {
    getArticle: (id: number) => Promise<void>,
    getOrder: (id: number) => Promise<void>,
    getProject: (id: number) => Promise<void>,
    getRelation: (id: number) => Promise<void>,
    getTask: (id: number) => Promise<void>,
    errorHandler: (err: number) => void
}

interface InstallOptions {
    errorNotifier?(message: string): void
    globalOpenHandler?(): void
    globalCloseHandler?(): void
    globalNotFoundHandler?(): void
}

const createErrorHandler = (errorNotifier: (message: string) => void) => (err: number): void => {
    switch (err) {
        case Errors.CompendaNotResponding:
            errorNotifier('Compenda lijkt niet te reageren')
            break
        case Errors.EntityNotFound:
            errorNotifier('Kan entiteit niet vinden')
            break
        default:
            errorNotifier('Er is een onbekende fout opgetreden')
            break
    }
}

export default function(Vue: VueConstructor, options?: InstallOptions) {
    if (options === undefined) options = {}
    if (options.globalOpenHandler === undefined) options.globalOpenHandler = () => {}
    if (options.globalCloseHandler === undefined) options.globalCloseHandler = () => {}
    if (options.globalNotFoundHandler === undefined) options.globalNotFoundHandler = () => {}

    CreateGlobalHandlers(options.globalOpenHandler, options.globalCloseHandler, options.globalNotFoundHandler)

    let errorHandler: (err: number) => void
    if (options.errorNotifier === undefined) {
        errorHandler = () => {}
    } else {
        errorHandler = createErrorHandler(options.errorNotifier)
    }

    const compendaFunctions: CompendaFunctionsInterface = {
        getArticle:  (id: number) => compenda(EntityType.Article, id),
        getOrder:    (id: number) => compenda(EntityType.Order, id),
        getProject:  (id: number) => compenda(EntityType.Project, id),
        getRelation: (id: number) => compenda(EntityType.Relation, id),
        getTask:     (id: number) => compenda(EntityType.Task, id),
        errorHandler,
    }
    Vue.prototype.$compenda = compendaFunctions
}

declare module 'vue/types/vue' {
    export interface Vue   {
        $compenda: CompendaFunctionsInterface
    }
}
